import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";
import { DefaultDateBehavior } from "./DefaultDateBehavior";
import { Age } from "../../../patient";

/** HIS項目患者月齢を生成する */
export class PtMonthAgeBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_MONTH_AGE";
  private static readonly PtBirthDateKey = "PT_BIRTHDATE";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === PtMonthAgeBehavior.Key).map(x => x.value);
    const behavior = new DefaultDateBehavior(PtMonthAgeBehavior.PtBirthDateKey);
    const values = behavior.getValue(hisInfoItems).data as Date[];
    const today = new Date();
    const monthAge = values.map(x => Age.calculate(x, today)).map(formatMonthAge);
    const data = itemValues.length > 0 ? itemValues : monthAge;
    return new HisInformationTextValue(PtMonthAgeBehavior.Key, data);
  }
}

function formatMonthAge(monthAge: Age): string {
  return monthAge.year + "歳 " + monthAge.month + "ヶ月";
}
